import React from "react";
import { InputProps as UIInputProps } from "@stemscopes/ui";
import uniqueId from "lodash-es/uniqueId";
import { formHooks } from "../../form/duck";
import InputError from "../input-error";
import StyledInternalInput from "../styled-internal-input";

const Input: React.FC<UIInputProps> = ({ name, stretch = true, ...rest }) => {
  const [field, { error }] = formHooks.useField<string>({ name });
  const errorId = React.useMemo(() => uniqueId("error-"), []);

  return (
    <>
      <StyledInternalInput
        {...field}
        {...rest}
        stretch={stretch}
        error={error}
        aria-errormessage={errorId}
        aria-invalid={!!error}
      />
      <InputError error={error} errorId={errorId} />
    </>
  );
};

export default Input;
